module.exports = {
  DomesticTrade: 'Domestic trade',
  SiruiPleaseContactTheTroubleshooting: 'Sirui consignment order push failed, please contact the staff for troubleshooting:',
  OperationFailed: 'Operation failed',
  PleaseCheckTheData: 'Please check the data',
  LockedContactAHigherUnlock: 'Locked, unable to print, please contact a higher-level supervisor to unlock!',
  AreCancelTheVoidingDocuments: 'Are you sure you want to cancel the voiding of the selected documents?',
  PleaseFormInvoiceEtcVoid: 'Please delete the expense confirmation form, invoice, etc. first, then void.',
  PleaseFromTheMasterVoid: 'Please remove this ticket from the master bill, then void.',
  PleaseFromThisMasterVoid: 'Please remove all tickets from this master bill, then void.',
  ThisThatRelevantDocumentsContinue: 'This business will be submitted for financial review, please confirm that relevant documents have been uploaded to the system before submitting, continue?',
  AttachmentContentIsTooLarge: 'Attachment content is too large',
  ThereBillNumbersProfitPrinted: 'There are foreign expenses without valid bill numbers, profit analysis table cannot be printed!',
  ThereBillNumbersProfitSubmitted: 'There are foreign expenses without valid bill numbers, profit analysis table cannot be submitted!',
  LockedPrintedOrEDINeeded: 'Locked due to credit control exceeded, this bill cannot be printed or EDI, please contact higher-level for unlocking when needed!',
  PleaseTicketToBeAdded: 'Please select the ticket to be added.',
  AreCopyTheMastersInformation: 'Are you sure you want to copy the master\'s consignor and consignee information?',
  MasterPleaseMaintainTheFirst: 'Master bill number cannot be empty, please maintain the master bill number first',
  PleaseTicketToBeEdited: 'Please select the ticket to be edited',
  Add: 'Add',
  AirImportCargoOperationDetails: 'Air import cargo operation details',
  ThisAlreadyAFormalBusiness: 'This ticket is already a formal business.'
}
